import { RequestService } from './requestService';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class PaymentService {
  private _apiEndpoint = environment.apiUrl;

  constructor(private _requestService: RequestService) {}
}
